import { createContext } from "react";

export interface AuthContext {
  isAuthenticated: boolean | null;
  organizationId?: string;
}

export const AuthContext = createContext<AuthContext>({
  isAuthenticated: null,
});
